import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a59d2a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 md:col-1 flex justify-content-center md:justify-content-start" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "col-12 lg:col-3" }
const _hoisted_4 = { class: "app-label-small text-default-gray font-bold" }
const _hoisted_5 = { class: "col-12 lg:col-2" }
const _hoisted_6 = { class: "app-label-small text-gray-l1 font-bold" }
const _hoisted_7 = { class: "col-12 lg:col-2" }
const _hoisted_8 = { class: "app-label-small text-gray-l1 font-bold" }
const _hoisted_9 = { class: "col-12 lg:col-2" }
const _hoisted_10 = { class: "col-12 lg:col-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.data?.imgURL,
        alt: "economy",
        class: "h-8rem md:h-3rem w-8rem md:w-3rem"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.data?.brand), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.data?.zone), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.factors, (factor) => {
        return (_openBlock(), _createElementBlock("i", {
          key: factor,
          class: _normalizeClass('ci-data-' + factor)
        }, null, 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "state",
        style: _normalizeStyle({ background: _ctx.stateColor(_ctx.data?.state) })
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.stateName(_ctx.data?.state)), 1)
      ], 4)
    ])
  ], 64))
}